import { CLIENT_ID, CLIENT_PUBLIC } from "../config";

//export const spotify_redirect_uri = "http://spotifyorganizer.maxpinheiro.com%2F%23%2Fspotifycallback";
//export const spotify_redirect_uri_unencoded = "http://spotifyorganizer.maxpinheiro.com/#/spotifycallback";
//export const spotify_redirect_uri = "http://maxpinheiro.com%2Fapps%2Fspotify-organizer%2F%23%2Fcallback";
//export const spotify_redirect_uri_unencoded = "http://maxpinheiro.com/apps/spotify-organizer/#/callback";
export const spotify_redirect_uri = "http://maxpinheiro.com%2Fapps%2Fspotify-organizer";
export const spotify_redirect_uri_unencoded = "http://maxpinheiro.com/apps/spotify-organizer";
//export const local_spotify_redirect_uri = "http://localhost:3000%2F%23%2Fcallback";
export const local_spotify_redirect_uri = "http://localhost:3000%2Fcallback";
export const local_spotify_redirect_uri_unencoded = "http://localhost:3000/callback";
const spotify_api_root = "https://api.spotify.com/v1";

export const jsonToUrlEncoded = (obj: any) => Object.keys(obj).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key])).join('&');

export enum ResponseStatus { Success = 200, UnknownError = 500, NotFound = 404, Unauthorized = 401 };

export type AccessTokenDto = {
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
}

export const refreshAndRetry = async () => {

}

export const refreshTokens = async () => {

}

export const getTokens = async (authCode: string, local=true): Promise<AccessTokenDto | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    const response = await fetch(`https://accounts.spotify.com/api/token`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Authorization": `Basic ${window.btoa(`${CLIENT_ID}:${CLIENT_PUBLIC}`)}`
        },
        body: jsonToUrlEncoded({
            grant_type: "authorization_code",
            code: authCode,
            redirect_uri: local ? local_spotify_redirect_uri_unencoded : spotify_redirect_uri_unencoded
        })
    });
    if (response.status === 200) {
        const data = await response.json();
        if (data.hasOwnProperty('access_token') && data.hasOwnProperty('refresh_token') && data.hasOwnProperty('expires_in')) {
            const accessToken = data['access_token'];
            const refreshToken = data['refresh_token'];
            const expiresIn = data['expires_in'];
            return { accessToken, refreshToken, expiresIn };
        } else {
            return ResponseStatus.UnknownError;
        }
    } else if (response.status === 401) {
        console.log(response);
        return ResponseStatus.Unauthorized;
    } else {
        return ResponseStatus.UnknownError;
    }
}

export type Track = {
    external_urls: {spotify: string};
    id: string;
    name: string;
    artists: {name: string}[];
    preview_url: string;
    uri: string;
    album: {images: {url: string}[]};
}

export type LikedSongsDto = {
    items: Track[];
    total: number;
}

export const getLikedSongs = async (accessToken: string, offset: number, limit: number): Promise<LikedSongsDto | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    const response = await fetch(`${spotify_api_root}/me/tracks?offset=${offset}&limit=${limit}`, {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
        }
    });
    if (response.status === 200) {
        const data = await response.json();
        if (data.hasOwnProperty('items') && data.hasOwnProperty('total')) {
            return { items: data.items.map((item: ({track: Track})) => item.track) as Track[], total: data.total };
            /*const items = data.items;
            return (items.map((item: ({track: Track})) => item.track)) as Track[];
            */
        } else {
            return ResponseStatus.UnknownError;
        }
    } else if (response.status === 401) {
        console.log(response);
        return ResponseStatus.Unauthorized;
    } else {
        return ResponseStatus.UnknownError;
    }
}

export const getLikedSongsTotalCount = async (accessToken: string): Promise<number | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    const singleSong = await getLikedSongs(accessToken, 0, 1);
    if (singleSong === ResponseStatus.Unauthorized || singleSong === ResponseStatus.UnknownError) return singleSong;
    return singleSong.total;
}

export const getAllLikedSongs = async (accessToken: string): Promise<Track[] | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    const totalNum = await getLikedSongsTotalCount(accessToken);
    if (totalNum === ResponseStatus.UnknownError) return ResponseStatus.UnknownError;
    let currOffset = 0;
    let currTotal = 0;
    let collectedSongs: Track[] = [];
    while (currTotal < totalNum) {
        const songs = await getLikedSongs(accessToken, currOffset * 50, 50);
        if (songs === ResponseStatus.UnknownError || songs === ResponseStatus.Unauthorized) {
            //return ResponseStatus.UnknownError;
            return songs;
        }
        collectedSongs.push(...songs.items);
        currTotal += 50;
        currOffset++;
    }
    return collectedSongs;
}

export type AudioFeature = {
    id: string;
    acousticness: number;
    danceability: number;
    energy: number;
    instrumentalness: number;
    liveness: number;
    loudness: number;
    mode: number;
    speechiness: number;
    valence: number;
}

export const emptyFeature: AudioFeature = {
    id: '0',
    acousticness: 0,
    danceability: 0,
    energy: 0,
    instrumentalness: 0,
    liveness: 0,
    loudness: 0,
    mode: 0,
    speechiness: 0,
    valence: 0,
}

export const getTracksAudioFeatures = async (accessToken: string, songIds: string[]): Promise<AudioFeature[] | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    const response = await fetch(`${spotify_api_root}/audio-features?ids=${songIds.join(',')}`, {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
        }
    });
    if (response.status === 200) {
        const data = await response.json();
        if (data.hasOwnProperty('audio_features')) {
            return data.audio_features as AudioFeature[];
        } else {
            return ResponseStatus.UnknownError;
        }
    } else if (response.status === 401) {
        console.log(response);
        return ResponseStatus.Unauthorized;
    } else {
        return ResponseStatus.UnknownError;
    }
}

export const getManyTracksAudioFeatures = async (accessToken: string, songIds: string[]): Promise<AudioFeature[] | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    const totalNum = songIds.length;
    let currTotal = 0;
    let collectedFeatures: AudioFeature[] = [];
    while (currTotal < totalNum) {
        const features = await getTracksAudioFeatures(accessToken, songIds.slice(currTotal, Math.min(currTotal+100, songIds.length)));
        if (features === ResponseStatus.UnknownError || features === ResponseStatus.Unauthorized) {
            //return ResponseStatus.UnknownError;
            return features;
        }
        collectedFeatures.push(...features);
        currTotal += 100;
    }
    return collectedFeatures;
}
